module.exports = ":host {\n  width: 100%; }\n  :host mat-form-field {\n    width: 100%; }\n  :host mat-icon {\n    padding-left: 0.75rem; }\n"